import { render } from "./FormPositionTrainingTable.vue?vue&type=template&id=46e743ee&scoped=true&ts=true"
import script from "./FormPositionTrainingTable.vue?vue&type=script&lang=ts"
export * from "./FormPositionTrainingTable.vue?vue&type=script&lang=ts"

import "./FormPositionTrainingTable.vue?vue&type=style&index=0&id=46e743ee&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e743ee"]])

export default __exports__